/**
 * Search page toolbar — live results in the product grid.
 */
(function () {
  const SELECTOR_TOOLBAR = '[data-search-toolbar]';
  const SELECTOR_INPUT = '[data-search-input]';
  const SELECTOR_CLEAR = '[data-search-clear]';
  const SELECTOR_SORT = '[data-search-sort]';
  const SELECTOR_COUNT = '[data-search-results-count]';
  const SELECTOR_CATALOG = '[data-collection-catalog]';
  const SELECTOR_RESULTS = '[data-collection-results]';
  const SELECTOR_GRID = '[data-collection-grid]';
  const SELECTOR_INFINITE = '[data-collection-infinite]';
  const SELECTOR_LOADING_TEMPLATE = '[data-collection-infinite-loading]';
  const SELECTOR_EMPTY_TEMPLATE = '[data-search-empty-query]';
  const SELECTOR_TITLE = '.search-page__header .content-header__title';
  const MIN_QUERY_LENGTH = 2;
  const DEBOUNCE_MS = 250;

  function shopRoot() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(
      /\/$/,
      ''
    );
  }

  function displayQuery(query) {
    return String(query || '')
      .trim()
      .replace(/\*+$/g, '')
      .replace(/(\S+)\*$/g, '$1');
  }

  function shopifyQuery(query) {
    const trimmed = displayQuery(query);
    if (!trimmed) return '';
    const parts = trimmed.split(/\s+/);
    parts[parts.length - 1] += '*';
    return parts.join(' ');
  }

  function searchParams(query, sortBy, forShopify) {
    const params = new URLSearchParams();
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    const value = forShopify ? shopifyQuery(query) : displayQuery(query);
    if (value) params.set('q', value);
    if (sortBy && sortBy !== 'relevance') params.set('sort_by', sortBy);
    return params;
  }

  function searchUrl(query, sortBy) {
    return shopRoot() + '/search?' + searchParams(query, sortBy, true).toString();
  }

  function initToolbar(toolbar) {
    if (toolbar.getAttribute('data-bound') === 'true') return;
    toolbar.setAttribute('data-bound', 'true');

    const input = toolbar.querySelector(SELECTOR_INPUT);
    const clearBtn = toolbar.querySelector(SELECTOR_CLEAR);
    const sortSelect = toolbar.querySelector(SELECTOR_SORT);
    const countEl = toolbar.querySelector(SELECTOR_COUNT);
    const emptyTemplate = toolbar.querySelector(SELECTOR_EMPTY_TEMPLATE);
    const results = document.querySelector(SELECTOR_RESULTS);
    const catalog = document.querySelector(SELECTOR_CATALOG);
    const sectionId = results ? results.getAttribute('data-section-id') : '';
    const titleDefault = toolbar.getAttribute('data-title-default') || '';
    const titleResultsTpl = toolbar.getAttribute('data-title-results') || '';

    let debounceTimer = null;
    let fetchController = null;
    let fetchId = 0;

    function currentQuery() {
      return displayQuery((input && input.value) || '');
    }

    function currentSort() {
      return (sortSelect && sortSelect.value) || 'relevance';
    }

    function setClearVisible(show) {
      if (!clearBtn) return;
      if (show) clearBtn.removeAttribute('hidden');
      else clearBtn.setAttribute('hidden', '');
    }

    function updateTitle(query) {
      const titleEl = document.querySelector(SELECTOR_TITLE);
      if (!titleEl) return;
      if (!query) {
        titleEl.textContent = titleDefault;
        return;
      }
      titleEl.textContent = titleResultsTpl.replace('__TERMS__', query);
    }

    function updateCount(countOrEl) {
      if (!countEl) return;
      if (countOrEl && countOrEl.nodeType === 1) {
        countEl.textContent = countOrEl.textContent;
        return;
      }
      const count = Number(countOrEl) || 0;
      const one = countEl.getAttribute('data-count-one') || '__COUNT__ produit';
      const other = countEl.getAttribute('data-count-other') || '__COUNT__ produits';
      const tpl = count === 1 ? one : other;
      countEl.textContent = tpl.replace('__COUNT__', String(count));
    }

    function ensureGrid() {
      if (!catalog) return null;
      let grid = catalog.querySelector(SELECTOR_GRID);
      if (!grid) {
        grid = document.createElement('ul');
        grid.className = 'collection-page__grid';
        grid.setAttribute('role', 'list');
        grid.setAttribute('data-collection-grid', '');
        catalog.appendChild(grid);
      }
      return grid;
    }

    function getGridColumnCount(grid) {
      if (!grid) return 1;
      const template = window.getComputedStyle(grid).getPropertyValue('grid-template-columns');
      const columns = template.split(/\s+/).filter(Boolean).length;
      return columns > 0 ? columns : 1;
    }

    function removeInfinite() {
      if (window.BricksartCollectionInfinite && typeof window.BricksartCollectionInfinite.pause === 'function') {
        window.BricksartCollectionInfinite.pause();
      }
      if (!catalog) return;
      catalog.querySelectorAll(SELECTOR_INFINITE).forEach(function (el) {
        el.remove();
      });
    }

    function showLoading() {
      const grid = ensureGrid();
      if (!grid) return;
      removeInfinite();
      grid.innerHTML = '';

      const template = document.querySelector(SELECTOR_LOADING_TEMPLATE);
      if (!template) return;

      const columns = getGridColumnCount(grid);
      const fragment = template.content.cloneNode(true);
      const item = fragment.querySelector('.collection-page__item--loading');
      if (item) item.style.gridColumn = 'span ' + columns;
      grid.appendChild(fragment);
    }

    function showEmptyQuery() {
      const grid = ensureGrid();
      if (!grid || !emptyTemplate) return;
      removeInfinite();
      grid.innerHTML = '';
      grid.appendChild(emptyTemplate.content.cloneNode(true));
      updateCount(0);
      updateTitle('');
    }

    function paintSection(doc) {
      const grid = ensureGrid();
      if (!grid || !catalog) return;

      const sourceGrid = doc.querySelector(SELECTOR_GRID);
      const sourceCount = doc.querySelector(SELECTOR_COUNT);
      const sourceInfinite = doc.querySelector(SELECTOR_INFINITE);

      removeInfinite();
      grid.innerHTML = '';

      if (sourceGrid) {
        Array.from(sourceGrid.children).forEach(function (item) {
          grid.appendChild(item);
        });
      }

      if (sourceCount) updateCount(sourceCount);

      if (sourceInfinite && sourceInfinite.getAttribute('data-next-url')) {
        catalog.appendChild(sourceInfinite);
        if (window.BricksartCollectionInfinite && typeof window.BricksartCollectionInfinite.refresh === 'function') {
          window.BricksartCollectionInfinite.refresh();
        }
      }
    }

    async function fetchResults(query, updateHistory) {
      if (!sectionId) return;

      const currentFetch = ++fetchId;
      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      if (results) results.setAttribute('aria-busy', 'true');
      showLoading();
      updateTitle(query);

      const params = searchParams(query, currentSort(), true);
      params.set('section_id', sectionId);

      try {
        const response = await fetch(shopRoot() + '/search?' + params.toString(), {
          headers: { Accept: 'text/html' },
          signal: fetchController.signal,
        });
        if (!response.ok) throw new Error('search_fetch_failed');

        const html = await response.text();
        if (currentFetch !== fetchId) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        paintSection(doc.querySelector('[id^="shopify-section-"]') || doc.body);

        document.dispatchEvent(
          new CustomEvent('analytics:search', {
            detail: {
              search_query: query,
              sort_by: currentSort(),
              source: 'search_page',
            },
          })
        );

        if (updateHistory) {
          history.replaceState({ searchLive: true }, '', searchUrl(query, currentSort()));
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error(error);
      } finally {
        if (currentFetch === fetchId && results) results.removeAttribute('aria-busy');
      }
    }

    function applyQuery(query, updateHistory) {
      setClearVisible(Boolean(query));

      if (query.length < MIN_QUERY_LENGTH) {
        if (fetchController) fetchController.abort();
        fetchId += 1;
        showEmptyQuery();
        if (updateHistory) history.replaceState({ searchLive: true }, '', searchUrl('', currentSort()));
        return;
      }

      fetchResults(query, updateHistory);
    }

    function scheduleQuery() {
      const query = currentQuery();
      setClearVisible(Boolean(query));
      if (debounceTimer) window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        applyQuery(query, true);
      }, DEBOUNCE_MS);
    }

    if (input) {
      input.addEventListener('input', scheduleQuery);
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) input.value = '';
        if (debounceTimer) window.clearTimeout(debounceTimer);
        applyQuery('', true);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const query = currentQuery();
        if (query.length < MIN_QUERY_LENGTH) {
          history.replaceState({ searchLive: true }, '', searchUrl('', currentSort()));
          return;
        }
        fetchResults(query, true);
      });
    }

    toolbar.addEventListener('submit', function (event) {
      event.preventDefault();
      if (debounceTimer) window.clearTimeout(debounceTimer);
      applyQuery(currentQuery(), true);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_TOOLBAR).forEach(initToolbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
